import styled, { css } from "styled-components";
import { Button } from "react-bootstrap";
import { media } from "../../utils/helper";

const StyledButton = ({ loading, children, icon, outlined, ...props }) => (
  <ButtonStyled outlined={outlined} disabled={loading} {...props}>
    <>
      <span
        style={{
          opacity: loading ? 0 : 1,
          transition: "opacity 0.2s ease-in",
        }}
      >
        {children}
      </span>
      {icon && (
        <span
          style={{
            opacity: loading ? 0 : 1,
            marginLeft: children ? 10 : 0,
            transition: "opacity 0.2s ease-in",
          }}
        >
          {icon}
        </span>
      )}
      {loading && (
        <div
          className="spinner-container"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 1,
          }}
        >
          <span className={`spinner spinner-border spinner-border-sm`} />
        </div>
      )}
    </>
  </ButtonStyled>
);

const buttonVariants = {
  white: css`
    color: ${({ theme }) => theme.colors.primary} !important;
    background: ${({ theme }) => theme.colors.primary} !important;

    &:hover,
    &:active,
    &:focus {
      background: ${({ theme }) => theme.colors.white} !important;
      color: ${({ theme }) => theme.colors.primary} !important;
      box-shadow: none;

      svg {
        color: ${({ theme }) => theme.colors.primary} !important;
      }
    }
  `,

  icon: css`
    color: ${({ theme }) => theme.colors.textColor} !important;
    background: ${({ theme }) => theme.colors.white} !important;
    box-shadow: 1px 1px 40px 0 #00000040;
    padding: 7px 9px 8px 9px;

    &:hover,
    &:active,
    &:focus {
      background: ${({ theme }) => theme.colors.white} !important;
      color: ${({ theme }) => theme.colors.textColor} !important;
      box-shadow: 1px 1px 40px 0 #00000040;

      svg {
        color: ${({ theme }) => theme.colors.textColor} !important;
      }
    }

    ${media.md`
       padding: 4px 7px 7px 7px;
     `}
  `,

  gray: css`
    color: ${({ theme }) => theme.colors.secondary} !important;
    background: ${({ theme }) => theme.colors.lightGray2} !important;

    &:hover,
    &:active,
    &:focus {
      background: ${({ theme }) => theme.colors.borderColor} !important;
      color: ${({ theme }) => theme.colors.secondary} !important;
      box-shadow: none;

      svg {
        color: ${({ theme }) => theme.colors.secondary} !important;
      }
    }
  `,

  danger: css`
    color: ${({ theme }) => theme.colors.white} !important;
    background: ${({ theme }) => theme.colors.danger} !important;

    &:hover,
    &:active,
    &:focus {
      background: ${({ theme }) => theme.colors.danger} !important;
      color: ${({ theme }) => theme.colors.white} !important;
      box-shadow: none;

      svg {
        color: ${({ theme }) => theme.colors.white} !important;
      }
    }
  `,

  primaryGradiant: css`
    transition:
      background 0.3s ease,
      color 0.3s ease;
    background: linear-gradient(89.92deg, #016d5b 0.07%, #00a79e 99.93%);

    &:hover,
    &:active,
    &:focus {
      background: linear-gradient(#017972, #017972);
    }
  `,
};

const ButtonStyled = styled(Button)`
  ${({ _variant, theme, size, weight, borderWidth, color, border }) => css`
    color: ${color ?? theme.colors.white} !important;
    background: linear-gradient(89.92deg, #01b093 0.07%, #00a79e 99.93%);
    font-size: ${size ?? "14px"} !important;
    font-weight: ${weight ?? "400"} !important;
    border-width: ${borderWidth ?? 0} !important;
    border-color: ${border ?? "inherit"} !important;
    ${buttonVariants[_variant] || ""}
    position: relative;
    ${media.md`
       ${({ $fontWeightMd }) => `${$fontWeightMd ? "font-weight:" + $fontWeightMd : ""}!important;`}
     `}
  `}
`;

export default StyledButton;
